import React from 'react'

import { colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/index'
import { Stack, XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { SH1, SH3 } from '@zet/design-system/typography'
import { BottomSheet } from '@zet/utils'
import * as ImagePicker from 'expo-image-picker'

import { i18n } from '../../localization'
import { DEVICE_WIDTH } from '../../utils/Constants'

const UploadProfilePicture = ({
  isUploadBottomSheetVisible,
  setIsUploadBottomSheetVisible,
  mutate,
}) => {

  const postImage = (result) => {
    const localUri = result.assets[0].uri

    const filename = localUri.split('/').pop()
    const match = /\.(\w+)$/.exec(filename)
    const type = match ? `image/${match[1]}` : `image`

    const formData = new FormData()
    formData.append('profilePic', {
      uri: localUri,
      name: filename,
      type,
    })

    mutate(formData)
  }

  const clickImage = async () => {
    try {
      const result = await ImagePicker.launchCameraAsync()

      if (!result.canceled) {
        postImage(result)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const pickImage = async () => {
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: 'images',
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    })

    if (result.canceled) return

    if (result?.assets?.[0]?.type === 'image') {
      postImage(result)
    }
  }

  return (
    <BottomSheet
      visible={isUploadBottomSheetVisible}
      disableBottomSheet={() => setIsUploadBottomSheetVisible(false)}
    >
      <Stack className="  self-center  " style={{ width: DEVICE_WIDTH }}>
        <XStack className="justify-between px-3 py-2">
          <SH1> {i18n.t('profilePic.add')} </SH1>
          <Pressable
            onPress={() => {
              setIsUploadBottomSheetVisible(false)
            }}
          >
            <Icon size={24} type="Close" />
          </Pressable>
        </XStack>
        <Stack className="border-grays-30  border-t p-3">
          <Pressable
            onPress={() => {
              pickImage()
              setIsUploadBottomSheetVisible(false)
            }}
          >
            <XStack className=" items-center ">
              <Icon type={'PhotoFilled'} color={zetColors.grays[80]} />
              <SH3 className="ml-[0.66rem]">{i18n.t('profilePic.upload')}</SH3>
            </XStack>
          </Pressable>
          <Pressable
            onPress={() => {
              clickImage()
              setIsUploadBottomSheetVisible(false)
            }}
          >
            <XStack className=" mt-3 items-center ">
              <Icon type={'CameraFilled'} color={zetColors.grays[80]} />
              <SH3 className="ml-[0.66rem]"> {i18n.t('profilePic.take')}</SH3>
            </XStack>
          </Pressable>
        </Stack>
      </Stack>
    </BottomSheet>
  )
}

export default UploadProfilePicture
